import { fExecuteAPI } from "../../Server/Apis";
import { DOReceiving_DoReceivingAttributes_GETROW } from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_WmsLoadingReceipt_HeadObject_Set,
  Set_LoadingReceipt_HeadObject_A_VocNo,
} from "./SliceWmsLoadingReceipt";

import { vRdxUserInfo, LoadingReceipt } from "../../Redux/roStore";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
 
// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = LoadingReceipt();

var vheaderArrow = 0;
export const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_ReceiptDt: "",
  A_Loc: "",
  Truck: "",
  Driver: "",
  xErrorMsg: "",
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_Unit: "",
  B_PackQty: "",
  B_BaseQty: "",
  Packing: "",
};
export const GridDataColumnsWmsSiDetail_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "H_SrNo", headerName: "Sr.No", width: 50 },
  { field: "H_ItmCd", headerName: "Item Code", width: 100 },
  { field: "ItmName", headerName: "Item Name", width: 300 },
  { field: "H_Qty", headerName: "Qty", width: 100 },
  { field: "H_Unit", headerName: "Unit", width: 100 },
  { field: "H_BaseQty", headerName: "BaseQty", width: 100 },
];
export const GridDataColumnsItemSearch_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
//GCSearch
export const GridDataColumnsSearch_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "VocName", headerName: "Doc.Name", width: 200 },
  { field: "A_VocNo", headerName: "Doc.No", width: 120 },
  {
    field: "A_VocDt",
    headerName: "Date",
    width: 90,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "B_RefDocNo", headerName: "Ref.No", width: 100 },
  { field: "A_Party", headerName: "Party", width: 300, hide: true },
  { field: "LocName", headerName: "Location", width: 130 },
  { field: "A_Cluster", headerName: "Cluster", width: 90, hide: true },
  { field: "A_Trans", headerName: "Transaction", width: 150, hide: true },
  { field: "A_Truck", headerName: "Truck", width: 90, hide: true },
  { field: "A_Driver", headerName: "Driver", width: 90, hide: true },
  { field: "A_DocStat", headerName: "Status", width: 90, hide: true },
  { field: "A_TruckCBM", headerName: "Truck CBM", width: 90, hide: true },
  { field: "A_Tot_CBM", headerName: "Total CBM", width: 90, hide: true },
  { field: "A_Tot_Weight", headerName: "Total Weight", width: 90, hide: true },
];
export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "LDRECPT";
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

const fKeyLoadingReceipt = (event) => {
  // WmsLoadingReceiptContent
  const form = document.getElementById("WmsLoadingReceiptHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyLoadingReceiptContent = (event) => {
  // WmsLoadingReceiptContent
  const form = document.getElementById("WmsLoadingReceiptContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ReceiptDt === "" ||
    vRdxHead.A_ReceiptDt === null ||
    vRdxHead.A_ReceiptDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ReceiptDt: "Receipt Date should not be Empty",
    }));
    fAlertToast("INFO", "Receipt Date should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Truck === "" ||
    vRdxHead.Truck === null ||
    vRdxHead.Truck === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Truck: "Truck should not be Empty" }));
    fAlertToast("INFO", "Truck should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Driver === "" ||
    vRdxHead.Driver === null ||
    vRdxHead.Driver === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Driver: "Driver should not be Empty" }));
    fAlertToast("INFO", "Driver should not be Empty");
    iRes = false;
  }

  if (vRdxHead.A_DocStat !== "ENTER") {
    fAlertToast("FAILED", "Document status should be Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Item code should not be zero",
    }));
    fAlertToast("INFO", "Item code should not be zero");
    iRes = false;
  }

  if (sBufferObj.Packing === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      Packing: "Packing should not be zero",
    }));
    fAlertToast("INFO", "Packing should not be zero");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

export const fBaseQtyCal = (B_Qty, B_PackQty, setBufferObj) => {
  let B_BaseQty = fcovertToNumber(B_Qty) * fcovertToNumber(B_PackQty);
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty: B_BaseQty,
  }));
};
//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  sBufferObj,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }

    await Unit_Onchange_001(
      vItemUnitSet,

      setBufferObj,
      sBufferObj
    );

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const Unit_Onchange_001 = async (
  xUnitObj = {},
  setBufferObj = () => {},
  sBufferObj
) => {
  //by sir
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
      Packing: xUnitObj?.PackDesc,
    }));
  }
  fBaseQtyCal(sBufferObj.B_Qty, xUnitObj?.PackQty, setBufferObj);
};
const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (xB_VocNo, xB_Srno, setDetailGridData, xVocTyp) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    VocTyp: !!xVocTyp ? xVocTyp : "",
    VocNo: !!xB_VocNo ? xB_VocNo : "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = await fExecuteAPI(
    "LoadingReceipt_LoadGrid_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult.ResultSet.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  }
};

//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = LoadingReceipt();
  const iStatus = HeadObject.A_DocStat; //xSave False means Post
  let vSaveSIHeadObj = {
    H_VocTyp: HeadObject?.A_VocTyp,
    H_VocNo: HeadObject?.A_VocNo,
    H_SrNo: sBufferObj.B_Srno,
    H_CardID: "",
    H_ItmCd: sBufferObj.B_Itmcd,
    H_Qty: sBufferObj.B_Qty,
    H_Unit: sBufferObj.B_Unit,
    H_BaseQty: sBufferObj.B_BaseQty,
    UserCd: vRdxUserInfoObj.UserID,
    Loc: HeadObject.A_Loc,
    A_DO_RCVD_DT: moment(HeadObject.A_ReceiptDt).format("MM/DD/YYYY"),
    IP: vRdxUserInfoObj.IP,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI(
    "LoadingReceipt_SaveDetails_GETROW",
    FinalObj
  );
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    // eslint-disable-next-line eqeqeq
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.A_VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_LoadingReceipt_HeadObject_A_VocNo({
        A_VocNo: HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    fNewDetail(HeadObject.A_VocNo, HeadObject?.A_VocTyp);
    fAlertToast("SUCCESS", "Successfully Saved");
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.message
        ? vSaveSIHead?.response?.data?.message
        : "Fail to Save Head"
    );
  }
};

const fApproveLoadingReceipt = async (dispatch, fNewDetail) => {
  const { HeadObject } = LoadingReceipt();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vSaveSIHeadObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
    ip: vRdxUserInfoObj.IP,
    usercd: vRdxUserInfoObj.UserID,
    Loc: HeadObject?.A_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI(
    "LoadingReceipt_Approve_GETROW",
    FinalObj
  );
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_LoadingReceipt_HeadObject_A_VocNo({
        A_VocNo: HeadObject.A_VocNo,
        A_DocStat: "POST",
      })
    );
    fDisplay(HeadObject.A_VocTyp, HeadObject.A_VocNo, dispatch, fNewDetail);

    fAlertToast("SUCCESS", "Successfully posted");
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.message
        ? vSaveSIHead?.response?.data?.message
        : "Fail to Save Head"
    );
  }
};
//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = LoadingReceipt();
  let vSIHeadObj = {
    VocTyp: xA_VocTyp,
    VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("LoadingReceipt_fDisplay_GETROW", FinalObj);

  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_WmsLoadingReceipt_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_VocDt,
        A_ReceiptDt: vSIHead.ResultSet[0].A_DO_RCVD_DT,
        A_Loc: vSIHead.ResultSet[0].A_DO_RCVD_Loc,
        A_DocStat: vSIHead.ResultSet[0].A_DO_RCVD_STATUS,
        Truck: vSIHead.ResultSet[0].TruckName,
        Driver: vSIHead.ResultSet[0].A_Driver,
      })
    );

    fNewDetail(vSIHead.ResultSet[0].A_VocNo, vSIHead.ResultSet[0].A_VocTyp);
  }
};

export const GetAttributes = async (
  setUser_Doc_Arr,
  setObjectRights,
  setDocLoading,
  setLocationArr
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await DOReceiving_DoReceivingAttributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setLocationArr(iAttributes?.data?.ResultSet?.Loaction);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export {
  // rows,
  // columns,
  fKeyLoadingReceipt,
  fKeyLoadingReceiptContent,
  // Api
  GetCheckboxUserRights,
  GetUnitArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fApproveLoadingReceipt,
};
